import { makeStyles, useTheme } from '@material-ui/core/styles';
import React, { HTMLAttributes } from 'react';

const useStyles = makeStyles({
    formRowLabel: {
        margin: '20px 0 5px 0',
        fontSize: '17px',
        fontWeight: 500,
    },
});

export interface FormRowLabelProps extends HTMLAttributes<HTMLDivElement> {
    text: string | JSX.Element;
    highlight?: boolean;
    style?: React.CSSProperties;
    disabled?: boolean;
    className?: string;
    isHtml?: boolean;
}

const FormRowLabel = ({
    text,
    highlight,
    style = undefined,
    disabled = false,
    className = '',
    isHtml = false,
    ...otherProps
}: FormRowLabelProps) => {
    const theme = useTheme();
    const classes = useStyles();

    return isHtml ? (
        <div
            className={classes.formRowLabel + ` ${className}`}
            style={{
                fontFamily: theme.typography.fontFamily,
                opacity: disabled ? 0.6 : 1,
                color: highlight ? theme.palette.error.main : 'rgba(0, 0, 0, 0.87)',
                ...style,
            }}
            dangerouslySetInnerHTML={{ __html: text.toString() }}
            {...otherProps}></div>
    ) : (
        <div
            className={classes.formRowLabel + ` ${className}`}
            style={{
                fontFamily: theme.typography.fontFamily,
                opacity: disabled ? 0.6 : 1,
                color: highlight ? theme.palette.error.main : 'rgba(0, 0, 0, 0.87)',
                ...style,
            }}
            {...otherProps}>
            {text}
        </div>
    );
};

export default FormRowLabel;
